export type CookieConsentLevel = 'all' | 'essential';

export interface CookieConsentRecord {
  level: CookieConsentLevel;
  updatedAt: string;
}

export const COOKIE_CONSENT_STORAGE_KEY = 'cd_cookie_consent';
